module.exports = __webpack_public_path__ + "img/title.ce16030d.png";